// extracted by mini-css-extract-plugin
export default {"container":"PermissaoNegada_container__j3qxq"};